import React from 'react';
import * as ReactDOM from 'react-dom';
import { compose } from 'ramda';

import styleFile from './SearchOptionCurrency.js';
import RichText from '@synergycms_core/components/generic/RichText';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { connect } from 'react-redux';
import actions from '../../../store/actions';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import { Image, Button } from '@synergycms_core/components/generic/';
import { withThemeJSS } from 'synergycms_core/src/components/providers/themeProvider';

const { currentCurrency: currentCurrencyAction } = actions.customer;
const { filters: filtersActions } = actions.customer;

const SearchOptionCurrency = class SearchOptionCurrency extends React.Component {
  static displayName = 'SearchOptionCurrency';
  constructor(props) {
    super(props);

    this.state = {
      selectedCurrency:
        this.props.config.hotelCurrencyCode === this.props.config.currentCurrencyCode
          ? 'HOTEL'
          : this.props.config.currentCurrencyCode,
      isVisible: true
    };
    this.currencySwitch = this.currencySwitch.bind(this);
    this.onCurrencyChange = this.props.config.onCurrencyChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.originalOverflow= document.body.style.overflow;
  }

  componentDidMount() {
    this.element = ReactDOM.findDOMNode(this);
    document.addEventListener("click", this.handleClickOutside);
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    this.applyBodyStyles();
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    document.body.style.overflow = this.originalOverflow;
  }

  applyBodyStyles() {
    if (window.innerWidth < 1001) {
      document.body.style.overflow = 'hidden hidden';
    } else {
      document.body.style.overflow = 'hidden auto';
    }
  }

  handleResize() {
    this.applyBodyStyles();
  }

  handleClickOutside(e) {
    if (!e || (this.element.contains && document.contains && !this.element.contains(e.target) && document.contains(e.target))) {
      e && e.preventDefault();
      this.props.config.toggleSelected('currencies')(e);
    }
  }

  handleScroll() {
    if (window.innerWidth >= 1001) {
      this.props.config.toggleSelected('currencies')();
      this.setState({ isVisible: false });
    }
  }

  currencySwitch = currencyCode => e => {
    e.preventDefault();
    if (currencyCode !== this.props.config.currentCurrencyCode) {
      this.props.config.innerStyle = styleFile.defaultStyle;
      this.onCurrencyChange(currencyCode);
      this.props.config.toggleSelected('currencies')(e);
      this.setState((state, props) => ({
        selectedCurrency: props.config.currentCurrencyCode
      }));
    }
  };

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;

    const currencyButton = currency => {
      return (
        <li key={'mainCurrencyLi' + currency.get('code')}>
          <Button
            key={'mainCurrencyButton' + currency.get('code')}
            innerStyle={
              this.state.selectedCurrency === currency.get('code')
                ? [classes.currencies, classes.selected]
                : [classes.currencies]
            }
            onClick={this.currencySwitch(currency.get('code'))}
            ariaLabel={'_%cambiar de moneda%_'}
            translate={true}>
            <RichText innerStyle={['black']}>
              <strong>{currency.get('code')}</strong> {currency.get('symbol')}
            </RichText>
          </Button>
        </li>
      );
    };

    return (
      <div className={theme.computedInnerStyle}>
        <div className={classes.currencyHeaderContainer}>
          {this.props.theme.width < 1001 && (
            <RichText
              translate={true}
              ucFirst={true}
              text={'_%cambiar de moneda%_'}
              innerStyle={classes.filterHeaderTitle}
            />
          )}
          <TooltipWrapper
            popover={
              <span className={[classes.currencyFilterPopover]}>
                <RichText
                  text={
                    '_%el pago se realizará al hotel en su moneda local. El importe que se muestra es orientativo y se calcula según el tipo de cambio vigente en el momento de la reserva.%_'
                  }
                  translate={true}
                  ucFirst={true}
                />
              </span>
            }
            popoverStyle={classes.currencyFilterTooltip}
            typeTooltip={'filterTooltip'}
            posX={'middle'}
            posY={'bottom'}
            avoidPointer={true}>
            <div className={classes.currenciesMoreInfo}>
              <Image svg={'infoIcon'} />
            </div>
          </TooltipWrapper>
          {this.props.theme.width < 1001 && (
            <Button
              onClick={this.props.config.toggleSelected()}
              innerStyle={['closeButton']}
              icon={{ unicodeContent: 'e001' }}
              defaultStyle={false}
              ariaLabel={'_%cerrar%_'}
              translate={true}
            />
          )}
        </div>

        <div className={classes.currencyContainer}>
          <div className={classes.titleContainer}>
            <div className={classes.infoTitleContainer}>
              <RichText ucFirst={true} plural={true} innerStyle={['bold', 'black', 'fontSize16']} translate={true}>
                _%monedas principales%_
              </RichText>
            </div>
          </div>
          <ul className={classes.currencyList}>
            <li key={'mainCurrencyLiHotel'}>
              <Button
                key={'mainCurrencyButtonHotel'}
                innerStyle={
                  this.state.selectedCurrency === 'HOTEL'
                    ? [classes.currencies, classes.selected]
                    : [classes.currencies]
                }
                onClick={this.currencySwitch(config.hotelCurrencyCode)}
                ariaLabel={'_%monedas principales%_'}
                translate={true}>
                <RichText innerStyle={['black']}>
                  <strong>Hotel</strong> €$£
                </RichText>
              </Button>
            </li>
            {config.mainCurrencies.size > 0 &&
              config.mainCurrencies.map(c => {
                return currencyButton(c);
              })}
          </ul>
          <div className={classes.titleContainer}>
            <div className={classes.infoTitleContainer}>
              <RichText ucFirst={true} innerStyle={['bold', 'black', 'fontSize16']} translate={true}>
                _%todas las monedas%_
              </RichText>
            </div>
          </div>
          <ul className={classes.currencyList}>
            {config.currencies.size > 0 &&
              config.currencies.map(c => {
                return currencyButton(c);
              })}
          </ul>
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = (dispatch, ownProps, state) => {
  return {
    onCurrencyChange: currencyCode => {
      dispatch(currentCurrencyAction.set(currencyCode));
      dispatch(actions.router.update());
      if (ownProps.type === 'multi') {
        dispatch(filtersActions.update());
      }
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  return {
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    currencies: store.getIn(['customer', 'currencies']),
    mainCurrencies: store.getIn(['customer', 'main_currencies'])
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'currentCurrencyCode',
    'mainCurrencies',
    'currencies',
    'hotelCurrencyCode',
    'onCurrencyChange',
    'toggleSelected',
    'type'
  ]),
  withThemeJSS({ styleFile, link: true })
)(SearchOptionCurrency);
